import { Text, TableData, Button, HStack } from '@wegroup/design-system';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellProps, Column, Renderer } from 'react-table';
import { toEuro } from '../../../../../../../sales-conversation/src/utils/stringUtils';
import { InsurancePolicy } from '../../../../../types/AdvisoryReport';

type CellRenderer = Renderer<CellProps<InsurancePolicy>>;

interface ReturnProps {
  columns: Column<TableData & InsurancePolicy>[];
}

interface Props {
  onSelect: (policy: InsurancePolicy) => void;
}

const usePrefillOfferInsurancePolicyTable = ({
  onSelect,
}: Props): ReturnProps => {
  const { t } = useTranslation();

  // const renderClosedAtDistCell: CellRenderer = ({ cell }) => {
  //   const { closed_at_distribution } = cell?.row?.original;

  //   return (
  //     <Text color="text.gray">
  //       {closed_at_distribution ? t('YES') : t('NO')}
  //     </Text>
  //   );
  // };

  const renderActionMenuCell: CellRenderer = ({ cell }) => {
    const policy = cell?.row?.original;

    return (
      <HStack justify="flex-end">
        <Button size="sm" variant="white" onClick={() => onSelect(policy)}>
          {t('SELECT')}
        </Button>
      </HStack>
    );
  };

  const renderDefaultCellFunc: CellRenderer = ({ cell }) => {
    const value = cell.value;
    return <Text color="text.gray">{value || '-'}</Text>;
  };

  const renderPremiumCellFunc: CellRenderer = ({ cell }) => {
    const { premium, payment_interval } = cell.row.original;
    return (
      <Text color="text.gray">
        {premium && payment_interval
          ? `${toEuro(premium)} / ${t(payment_interval)}`
          : premium
          ? toEuro(premium)
          : '-'}
      </Text>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: t('NAME'),
        accessor: 'name',
        Cell: renderDefaultCellFunc,
        isSticky: true,
      },
      {
        Header: t('Policy nr'),
        accessor: 'policy_nr',
        Cell: renderDefaultCellFunc,
      },
      {
        Header: t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PREMIUM'),
        accessor: 'premium',
        Cell: renderPremiumCellFunc,
      },
      // {
      //   Header: t('FLOWS_COMPANY-SCAN_CURRENT-INSURANCES-INPUT_CLOSED-AT-DIST'),
      //   accessor: 'closed_at_distribution',
      //   Cell: renderClosedAtDistCell,
      // },
      {
        id: 'actions',
        Cell: renderActionMenuCell,
        disableSortBy: true,
        isSticky: true,
      },
    ],
    [],
  );
  return { columns };
};

export default usePrefillOfferInsurancePolicyTable;
